import React from 'react';
import StyledButton from '@src/components/wysiwyg_editor/page_content_items/control_panels/StyledButton';
import replaceImg from '@images/wysiwyg_editor/control_panels/replace.svg';
import replaceHoverImg from '@images/wysiwyg_editor/control_panels/replace-hover.svg';

type TProps = {
  onClick: () => void;
};

function Replace(props: TProps) {
  return (
    <StyledButton
      image={replaceImg as string}
      hoverImage={replaceHoverImg as string}
      onClick={props.onClick}
    >
      Replace
    </StyledButton>
  );
}

export default Replace;
